export const createDateString = (date: Date): string => {
    return date.toISOString().split("T")[0];
};
